import { configureStore as configureStoreReduxToolkit } from '@reduxjs/toolkit';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { rootReducer } from '../../redux/reducers';

const reducer = rootReducer();

export const configureStore = () =>
    configureStoreReduxToolkit({
        reducer,
        middleware: getDefaultMiddleware => getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }),
    });

export const store = configureStore();

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export type RootState = ReturnType<typeof store.getState>;
